module.exports = __webpack_public_path__ + "img/hakhak_app_1.3ac839b5.png";